module.exports = __webpack_public_path__ + "media/about/ray-marchand-64b1107e.jpg";